export default __webpack_public_path__ + "static/media/Frame.17e8891c.svg";